import { render } from "./EmployeeClearance.vue?vue&type=template&id=4e2eb00a&scoped=true"
import script from "./EmployeeClearance.vue?vue&type=script&lang=js"
export * from "./EmployeeClearance.vue?vue&type=script&lang=js"

import "./EmployeeClearance.vue?vue&type=style&index=0&id=4e2eb00a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2eb00a"]])

export default __exports__